
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Crea dashboard',
	'dashboard': 'Dashboard',
	'dashboardTemplate': 'Modello di dashboard',
	'createAV': 'Crea',
	'createAvEditNameLabel': '1. Denominare la vista',
	'createAvSelectTemplateLabel': '2. Seleziona un modello',
	'tabLayoutLabel': 'Modello a schede',
	'infographicsLayoutLabel': 'Modello Infografica',
	'singlePageLayoutLabel': 'Modello di pagina singola',
	'customLayoutLabel': 'Modello personalizzato',
	'freeformTemplate': 'Formato libero',
	'freeformTemplateDesc': 'Le visualizzazioni in un formato libero vengono visualizzate esattamente con le dimensioni e nella posizione definita dall\'utente nella vista, indipendentemente dalla dimensione dello schermo. In altri layout, la dimensione e posizione delle visualizzazioni si modificano per adattarsi allo schermo.',
	'NoTemplate': 'Free form',
	'Template1': 'Vuoto',
	'Template2': 'Title 1 by 2',
	'Template3': '2 over 1',
	'Template4': '4 over 1',
	'Template5': 'Footer 1 by 2',
	'Template6': '3 beside 1 over 1',
	'Template7': '4 beside 3 over 1',
	'Template8': '2 over 3 by 2',
	'Template9': '2 by 2',
	'Template10': '1 by 2 beside 2 by 2 over 1',
	'Template11': '3 by 1 over 1 by 2',
	'Template12': '2 over 1 beside 1 by 2',
	'Template13': 'One beside 1 by 2 beside 1 by 4',
	'Template22': '1 su 2 di 2',
	'Template14': '1 accanto a 1',
	'Template15': '1 su 1 accanto a 1',
	'Template16': '1 accanto a 1 su 1',
	'Template17': '1 su 1 accanto a 1 su 1',
	'Template18': '1 su 1 accanto a 1',
	'Template19': '1 su 2 accanto a 1',
	'Template20': '1 su 2 di 1',
	'Template21': '1 su 1 su 2 di 1',
	'Template23': 'Vuoto con Dropzone',
	'Infographics1': 'Vuoto',
	'Infographics2': '4 righe',
	'Infographics3': '4 righe con intestazioni',
	'Infographics4': '2 da 4',
	'Infographics5': 'Ampio display superiore con 2 per 2',
	'Infographics6': '2 per 4 con spazio verticale',
	'Infographics7': '2 per 4 sfalsati',
	'Infographics8': 'Campo da tennis',
	'Infographics9': '3 per 4',
	'Infographics10': '4 per 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Il modello di dashboard è stato salvato.',
	'dashboard_template_prefix': 'Modello: "%{name}"',
	'dashboard_template_filters_removed': 'I filtri sull\'area di lavoro sono stati rimossi.',
	'createAvTabLabel': 'Con schede',
	'createAvInfographicsLabel': 'Infografica',
	'createAvSinglepageLabel': 'Pagina singola',
	'createAvCustomLabel': 'Personalizzato',
	'loadMoreLabel': 'Carica altro...',
	'backLabel': 'Torna indietro',
	'addSourceLabel': 'Aggiungi un\'origine',
	'pinLabel': 'Blocca',
	'errorLoadingDataSetMetaData': 'Si è verificato un errore durante la lettura dei metadati',
	'errorLoadingDataSets': 'Si è verificato un errore durante il caricamento dell\'elenco di dataset.',
	'errorLoadingDataSet': 'I metadati per il dataset "%{datasetName}"  non sono stati caricati. Contattare l\'amministratore per i dettagli.',
	'okButton': 'OK',
	'createButton': 'Crea',
	'cancelButton': 'Annulla',
	'copyButton': 'Copia',
	'selectTemplateLabel': 'Selezionare un modello',
	'createBoardTitle': 'Crea una dashboard',
	'createBoardSubtitle': 'Selezionare un modello per il proprio dashboard',
	'noSourcesSelectedLabel': 'Nessuna origine selezionata',
	'find_label': 'Trova',
	'noDashboardFound': 'Impossibile recuperare il dashboard. È possibile che non esista o che non si dispone dei privilegi sufficienti per visualizzarlo.',
	'errorLabel': 'Errore',
	'defaultName': 'Nuovo dashboard',
	'noDashboardCapability': 'L\'utente non ha la possibilità di eseguire l\'applicazione dashboard.',
	'noDashboardPermission': 'L\'utente non dispone dei privilegi sufficienti per visualizzare questo dashboard',
	'sourceNotFound': 'Impossibile caricare la visualizzazione perché l\'origine associata "%{sourceName}" non è disponibile.',
	'cmDuplicateName': 'Già esiste un elemento con questo nome. Tenta con un altro nome',
	'cmEmptySelection': 'Il dashboard è stato eliminato. Tentare di salvare come un nuovo dashboard.',
	'propTheme': 'Tema visivo',
	'legacyThemeLabel': 'Legacy',
	'carbonGrey10Label': 'Carbon X chiaro',
	'carbonGrey100Label': 'Carbon X scuro',
	'titleTextLabel': 'Titolo',
	'titleSmallTextLabel': 'Titolo breve',
	'subtitleTextLabel': 'Sottotitolo',
	'bodyTextLabel': 'Corpo',
	'bodySmallTextLabel': 'Corpo piccolo',
	'captionTextLabel': 'Didascalia',
	'quoteTextLabel': 'Virgolette',
	'quoteSmallTextLabel': 'Virgolette piccole',
	'responsiveTextLabel': 'Dimensionamento automatico',
	'mediaWidgetLabel': 'Supporti',
	'webpageWidgetLabel': 'Pagina Web',
	'imageWidgetLabel': 'Immagine',
	'textWidgetLabel': 'Testo',
	'notebookWidgetLabel': 'Blocco note',
	'multipurposeWidgetLabel': 'Multifunzione',
	'textPlaceHolder': 'Fare clic per modificare il testo',
	'titlePlaceHolder': 'Fare clic per modificare il titolo',
	'toggleEditModeLabel': 'Passa alla modifica',
	'togglePreviewModeLabel': 'Passa all\'anteprima',
	'editDashboardCoachMarkTitle': 'Modifica dashboard',
	'editDashboardCoachMarkContents': 'Fare clic sull\'icona matita per modificare questo dashboard.',
	'addDataCoachMarkTitle': 'Aggiungi dati',
	'addDataDashboardCoachMarkContents': 'Trascinare e rilasciare i dati dal pannello di dati al proprio dashboard.',
	'pageSelectWarning': 'Selezionare una scheda.',
	'screenshot_label': 'Dashboard %{title}',
	'screenshot_label_tab': 'Scheda %{tabName} del dashboard %{title}',
	'dataAssetPropertiesLabel': 'Proprietà di visualizzazione',
	'modelFilter': 'Filtro',
	'invertSelectionToolTip': 'Inverti selezioni filtro',
	'clearFilterValueToolTip': 'Annulla valori del filtro',
	'invertFilterSelection': 'Inverti',
	'clearTextFilterValue': 'Annulla',
	'filterConditionLabel': 'Condizione filtro',
	'applyFilter': 'Applica filtro',
	'itemCountText': '%{itemCount} Elementi selezionati',
	'itemExcludeCountText': '%{itemCount} Elementi esclusi',
	'moreMembers': 'Mostra altro...',
	'searchHierarchyMembers': 'Utilizza la ricerca per trovare i membri...',
	'propHideEmpty': 'Nascondi elemento vuoto',
	'propColorOrder': 'Ordine colori',
	'propElementColor': 'Colore elemento di visualizzazione',
	'propLineColor': 'Colore linea',
	'propLineAndSymbolColor': 'Colore linea e simbolo',
	'propColumnColor': 'Colore colonna',
	'propBarColor': 'Colore barra',
	'propWordColor': 'Colore parola',
	'propAreaColor': 'Colore area',
	'propRadialbarColor': 'Colore barra radiale',
	'propColorPalettes': 'Tavolozze dei colori',
	'propDashboardColorPalette': 'Tavolozza dashboard corrente',
	'propNewDashboardPaletteLabel': 'Crea una tavolozza dashboard personalizzata',
	'propDashboardChangePaletteLink': 'Modifica tavolozza dashboard',
	'propHideLeafNode': 'Nascondi etichette principali',
	'propOpacity': 'Opacità',
	'propOpacityDescription': 'Rende l\'oggetto più o meno opaco. Immettere un valore compreso tra 0 e 100',
	'addATab': 'Aggiungi una nuova scheda',
	'propFredIsRed': 'Congruenza colore',
	'areaChartCaption': 'Area',
	'areaChartDataSlot_categoriesLabel': 'Etichetta asse',
	'areaChartDataSlot_valuesLabel': 'Valore',
	'areaChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'areaChartProp_lineColorLabel': 'Colore area',
	'areaChartProp_interpolationLabel': 'Linee smussate',
	'areaChartProp_interpolationDescription': 'Le linee che collegano i punti dati sono ricurve.',
	'areaChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'areaChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'areaChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'areaChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'areaChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'areaChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'barChartCaption': 'Barra',
	'barChartDataSlot_categoriesLabel': 'Etichetta asse',
	'barChartDataSlot_valuesLabel': 'Valore',
	'barChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'barChartProp_elementColorLabel': 'Colore barra',
	'barChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'barChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'barChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'barChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'barChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'barChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'barChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'barChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'columnChartCaption': 'Colonna',
	'columnChartDataSlot_categoriesLabel': 'Etichetta asse',
	'columnChartDataSlot_valuesLabel': 'Valore',
	'columnChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'columnChartProp_elementColorLabel': 'Colore colonna',
	'columnChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'columnChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'columnChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'columnChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'columnChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'columnChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'bubbleChartCaption': 'Bolle',
	'bubbleChartDataSlot_xAxisLabel': 'Asse orizzontale',
	'bubbleChartDataSlot_yAxisLabel': 'Asse verticale',
	'bubbleChartDataSlot_sizeLabel': 'Dimensione per',
	'bubbleChartDataSlot_colorLabel': 'Colore per',
	'bubbleChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'bubbleChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'bubbleChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'bubbleChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'bubbleChartProp_hideLegendLabel': 'Nascondi legenda',
	'bubbleChartProp_hideLegendDescription': 'Nascondi la legenda.',
	'bubbleChartProp_legendPositionLabel': 'Posizione legenda',
	'lineChartCaption': 'Riga',
	'lineChartDataSlot_categoriesLabel': 'Etichetta asse',
	'lineChartDataSlot_valuesLabel': 'Valore',
	'lineChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'lineChartProp_lineColorLabel': 'Colore linea e simbolo',
	'lineChartProp_symbolShapeLabel': 'Forma simbolo',
	'lineChartProp_hideSymbolsLabel': 'Nascondi simboli',
	'lineChartProp_hideSymbolsDescription': 'Nascondi simboli',
	'lineChartProp_hideDataLinesLabel': 'Nascondi linee',
	'lineChartProp_hideDataLinesDescription': 'Nascondi linee',
	'lineChartProp_interpolationLabel': 'Linee smussate',
	'lineChartProp_interpolationDescription': 'Le linee che collegano i punti dati sono ricurve.',
	'lineChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'lineChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'lineChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'lineChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'lineChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'lineChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'packedBubbleChart1CatCaption': 'Diagramma a bolle',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categorie',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Dimensione per',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Tavolozze dei colori',
	'packedBubbleChart1CatProp_elementColorLabel': 'Colore bolla',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Nascondi etichetta',
	'packedBubbleChart1CatProp_hideValueLabel': 'Nascondi valore',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'heatChartCaption': 'Calore',
	'heatChartDataSlot_valuesLabel': 'Calore per',
	'heatChartDataSlot_xAxisLabel': 'Asse orizzontale',
	'heatChartDataSlot_yAxisLabel': 'Asse verticale',
	'heatChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'heatChartProp_heatScalePaletteLabel': 'Ordine colori',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'heatChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'heatChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'heatChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'heatChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'heatChartProp_hideLegendLabel': 'Nascondi legenda',
	'heatChartProp_hideLegendDescription': 'Nascondi la legenda.',
	'heatChartProp_legendPositionLabel': 'Posizione legenda',
	'pieChartCaption': 'Torta',
	'pieChartDataSlot_categoriesLabel': 'Categorie',
	'pieChartDataSlot_valuesLabel': 'Valore',
	'pieChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'pieChartProp_hideRadialValueLabel': 'Nascondi valore',
	'pieChartProp_pieAsDonutLabel': 'Visualizza come grafico ad anello',
	'pieChartProp_pieAsDonutDescription': 'Visualizza come grafico ad anello',
	'pieChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'pieChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'pieChartProp_hideLegendLabel': 'Nascondi legenda',
	'pieChartProp_hideLegendDescription': 'Nascondi la legenda.',
	'pieChartProp_legendPositionLabel': 'Posizione legenda',
	'map1measureCaption': 'Mappa',
	'map1measureDataSlot_categoriesLabel': 'Regioni',
	'map1measureDataSlot_valuesLabel': 'Calore regione',
	'map1measureProp_colorPaletteLabel': 'Tavolozze dei colori',
	'map1measureProp_heatScalePaletteLabel': 'Ordine colori',
	'map1measureProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'map1measureProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'map1measureProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'map1measureProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'map1measureProp_hideLegendLabel': 'Nascondi legenda',
	'map1measureProp_hideLegendDescription': 'Nascondi la legenda.',
	'map1measureProp_legendPositionLabel': 'Posizione legenda',
	'radialChartCaption': 'Radiale',
	'radialChartDataSlot_categoriesLabel': 'Categorie',
	'radialChartDataSlot_valuesLabel': 'Valore',
	'radialChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'radialChartProp_elementColorLabel': 'Colore barra radiale',
	'radialChartProp_hideRadialTitleLabel': 'Nascondi titolo',
	'radialChartProp_hideRadialValueLabel': 'Nascondi valore',
	'radialChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'radialChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'radialChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'radialChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'pointChart1catCaption': 'Punti',
	'pointChart1catDataSlot_valuesLabel': 'Valore',
	'pointChart1catDataSlot_categoriesLabel': 'Etichetta asse',
	'pointChart1catProp_colorPaletteLabel': 'Tavolozze dei colori',
	'pointChart1catProp_elementColorLabel': 'Colore forma',
	'pointChart1catProp_symbolShapeLabel': 'Forma simbolo',
	'pointChart1catProp_symbolFillLabel': 'Forma riempimento',
	'pointChart1catProp_symbolFillDescription': 'Visualizza colore riempimento per i simboli.',
	'pointChart1catProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'pointChart1catProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'pointChart1catProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'pointChart1catProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'pointChart1catProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'scatterPlotChartNoCatCaption': 'A dispersione',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Asse orizzontale',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Asse verticale',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Tavolozze dei colori',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Colore elemento',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Forma simbolo',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Forma riempimento',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Visualizza colore riempimento per i simboli.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'radialBarChartCaption': 'Barra radiale',
	'radialBarChartDataSlot_categoriesLabel': 'Categorie',
	'radialBarChartDataSlot_valuesLabel': 'Valore',
	'radialBarChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'radialBarChartProp_elementColorLabel': 'Colore barra radiale',
	'radialBarChartProp_hideRadialTitleLabel': 'Nascondi titolo',
	'radialBarChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'radialBarChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'radialBarChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'radialBarChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'lineColumnComboChartCaption': 'Linea e colonna',
	'lineColumnComboChartDataSlot_categoryLabel': 'Etichetta asse',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Valore linea',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Valore colonna',
	'lineColumnComboChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'lineColumnComboChartProp_elementColorLabel': 'Colore colonna',
	'lineColumnComboChartProp_lineColorLabel': 'Colore linea e simbolo',
	'lineColumnComboChartProp_symbolShapeLabel': 'Forma simbolo',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Nascondi simboli',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Nascondi simboli',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Nascondi linee',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Nascondi linee',
	'lineColumnComboChartProp_interpolationLabel': 'Linee smussate',
	'lineColumnComboChartProp_interpolationDescription': 'Le linee che collegano i punti dati sono ricurve.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Nascondi linee griglia',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Nascondi linee griglia',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Nascondi le etichette del titolo dell\'asse',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Nascondi i titoli per l\'asse.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'lineColumnComboChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'lineColumnComboChartProp_hideLegendLabel': 'Nascondi legenda',
	'lineColumnComboChartProp_hideLegendDescription': 'Nascondi la legenda.',
	'lineColumnComboChartProp_legendPositionLabel': 'Posizione legenda',
	'summaryCaption': 'Riepilogo',
	'areaName': 'Area',
	'areaDescription': 'Area',
	'areaDataSlot_colorLabel': 'Colore per',
	'areaDataSlot_valuesLabel': 'Valore',
	'areaDataSlot_categoriesLabel': 'Etichetta asse',
	'bubbleName': 'Bolle',
	'bubbleDescription': 'Bolle',
	'bubbleDataSlot_yAxisLabel': 'Asse verticale',
	'bubbleDataSlot_xAxisLabel': 'Asse orizzontale',
	'bubbleDataSlot_sizeLabel': 'Dimensione per',
	'bubbleDataSlot_colorLabel': 'Colore per',
	'clusterBarName': 'Barra',
	'clusterBarDescription': 'Barra',
	'clusterBarDataSlot_colorLabel': 'Colore per',
	'clusterBarDataSlot_valuesLabel': 'Valore',
	'clusterBarDataSlot_categoriesLabel': 'Etichetta asse',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Valore',
	'clusterColumnName': 'Colonna',
	'clusterColumnDescription': 'Colonna',
	'clusterColumnDataSlot_colorLabel': 'Colore per',
	'clusterColumnDataSlot_valuesLabel': 'Valore',
	'clusterColumnDataSlot_categoriesLabel': 'Etichetta asse',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Valore',
	'clusterLineName': 'Riga',
	'clusterLineDescription': 'Riga',
	'clusterLineDataSlot_colorLabel': 'Colore per',
	'clusterLineDataSlot_valuesLabel': 'Asse verticale',
	'clusterLineDataSlot_categoriesLabel': 'Asse orizzontale',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Valore',
	'gridName': 'Griglia',
	'gridDescription': 'Griglia',
	'gridDataSlot_grid_colsLabel': 'Colonna',
	'heatName': 'Calore',
	'heatDescription': 'Calore',
	'heatDataSlot_yAxisLabel': 'Asse verticale',
	'heatDataSlot_xAxisLabel': 'Asse orizzontale',
	'heatDataSlot_valuesLabel': 'Calore per',
	'lineColumnComboName': 'Linea e colonna',
	'lineColumnComboDescription': 'Linea e colonna',
	'lineColumnComboDataSlot_lineValueLabel': 'Valore linea',
	'lineColumnComboDataSlot_categoryLabel': 'Etichetta asse',
	'lineColumnComboDataSlot_columnValueLabel': 'Valore colonna',
	'mapName': 'Mappa legacy',
	'mapDescription': 'Mappa legacy',
	'mapDataSlot_sizeLabel': 'Dimensione punto',
	'mapDataSlot_valuesLabel': 'Calore regione',
	'mapDataSlot_sizeHeatLabel': 'Calore punto',
	'mapDataSlot_categoriesLabel': 'Regioni',
	'packedBubbleName': 'Diagramma a bolle',
	'packedBubbleDescription': 'Diagramma a bolle',
	'packedBubbleDataSlot_sizeLabel': 'Dimensione per',
	'packedBubbleDataSlot_colorLabel': 'Colore per',
	'packedBubbleDataSlot_categoriesLabel': 'Categorie',
	'pieName': 'Torta',
	'pieDescription': 'Torta',
	'pieDataSlot_valuesLabel': 'Valore',
	'pieDataSlot_categoriesLabel': 'Categorie',
	'playerName': 'Data player',
	'playerDescription': 'Data player',
	'playerDataSlot_categoriesLabel': 'Etichetta asse',
	'pointName': 'Punti',
	'pointDescription': 'Punti',
	'pointDataSlot_colorLabel': 'Colore per',
	'pointDataSlot_valuesLabel': 'Valore',
	'pointDataSlot_categoriesLabel': 'Etichetta asse',
	'radialName': 'Radiale',
	'radialDescription': 'Radiale',
	'radialDataSlot_valuesLabel': 'Valore',
	'radialDataSlot_maxSizeLabel': 'Valore massimo',
	'radialDataSlot_categoriesLabel': 'Categorie',
	'radialBarName': 'Barra radiale',
	'radialBarDescription': 'Barra radiale',
	'radialBarDataSlot_valuesLabel': 'Valore',
	'radialBarDataSlot_categoriesLabel': 'Categorie',
	'scatterPlotName': 'A dispersione',
	'scatterPlotDescription': 'A dispersione',
	'scatterPlotDataSlot_yAxisLabel': 'Asse verticale',
	'scatterPlotDataSlot_xAxisLabel': 'Asse orizzontale',
	'scatterPlotDataSlot_colorLabel': 'Colore per',
	'scatterPlotDataSlot_categoriesLabel': 'Punti',
	'stackedBarName': 'Barre in pila',
	'stackedBarDescription': 'Barre in pila',
	'stackedBarDataSlot_colorLabel': 'Colore per',
	'stackedBarDataSlot_valuesLabel': 'Valore',
	'stackedBarDataSlot_categoriesLabel': 'Etichetta asse',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Valore',
	'stackedColumnName': 'Colonna in pila',
	'stackedColumnDescription': 'Colonna in pila',
	'stackedColumnDataSlot_colorLabel': 'Colore per',
	'stackedColumnDataSlot_valuesLabel': 'Valore',
	'stackedColumnDataSlot_categoriesLabel': 'Etichetta asse',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Valore',
	'summaryChartName': 'Riepilogo',
	'summaryChartDescription': 'Riepilogo',
	'summaryChartDataSlot_valuesLabel': 'Valore',
	'treeMapName': 'Mappa struttura ad albero',
	'treeMapDescription': 'Mappa struttura ad albero',
	'treeMapDataSlot_colorLabel': 'Calore per',
	'treeMapDataSlot_valuesLabel': 'Dimensione per',
	'treeMapDataSlot_categoriesLabel': 'Livello uno',
	'treeMapDataSlot_level3Label': 'Livello tre',
	'treeMapDataSlot_level2Label': 'Livello due',
	'wordCloudName': 'Word cloud',
	'wordCloudDescription': 'Word cloud',
	'wordCloudDataSlot_colorLabel': 'Colore per',
	'wordCloudDataSlot_scaleLabel': 'Dimensione per',
	'wordCloudDataSlot_wordLabel': 'Parole',
	'treeMap1Cat1MeasureChartCaption': 'Mappa struttura ad albero',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Livello uno',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Dimensione per',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Tavolozze dei colori',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Nascondi legenda',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Nascondi la legenda.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Posizione legenda',
	'wordChart1Cat1MeasureCaption': 'Word cloud',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Parole',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Dimensione per',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Tavolozze dei colori',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Colore parola',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Conserva scala asse',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Sull\'asse visualizza sempre i valori minimo e massimo.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Nascondi elemento vuoto',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Nascondi categorie a cui non è associato alcun valore.',
	'missingDataSetData': 'I dati per questo dataset non sono disponibili. Aggiornare il dataset o rivolgersi all\'amministratore per accedere all\'origine.',
	'hideShowSummaries': 'Nascondi/Mostra riepiloghi',
	'crosstabName': 'Tabella incrociata',
	'value_is_not_available': 'N/D',
	'swapRowsAndColumns': 'Inverti righe e colonne',
	'NoPinsCollected': 'Nessuna visualizzazione bloccata',
	'pinSearchOld': 'Ricerca blocchi personali',
	'pinDeletedToast': 'Il blocco è stato rimosso',
	'pinAddedToast': 'Il blocco è stato correttamente aggiunto a Blocchi personali',
	'pinRetrieveError': 'Impossibile recuperare uno o più blocchi. Riprovare in seguito.',
	'pinErrorTitle': 'Errore Pinning',
	'pinRemove': 'Rimuovi il blocco',
	'deletePin': 'Elimina il blocco',
	'dataset_time': 'ora',
	'dataset_date': 'data',
	'dataset_location': 'ubicazione',
	'dataset_number': 'numero',
	'dataset_text': 'testo',
	'widgetConditionalFormatLabel': 'Attiva/disattiva i controlli di formato condizionali',
	'deletePinConfirmationMessage': 'Si è sicuri di voler eliminare questo blocco? Questa operazione non può essere annullata.',
	'deletePinConfirm': 'Conferma eliminazione',
	'pinDeleteError': 'Impossibile eliminare uno o più blocchi. Riprovare in seguito.',
	'metadataPickerTitle': 'Crea dataset',
	'moreTitle': 'Altro',
	'remove_slider_handle': 'Rimuovi handle',
	'missingFiltering': 'colonna mancante:',
	'unSupportedPromptType': 'Lo scenario di prompt non è attualmente supportato.',
	'preAggregateLabel': 'Applica i valori di prompt dell\'origine dati',
	'postAggregateLabel': 'Applica i valori di prompt nel report',
	'preAggregateText': 'L\'intervallo utilizza i valori nell\'origine dati, non i valori visualizzati nel dashboard.',
	'tabName_general': 'Generale', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Dettagli',
	'tabName_textDetails': 'Dettagli testo', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Dettagli supporti', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Dettagli pagina Web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Dettagli immagine', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualizzazione',
	'sectionName_canvas': 'Area di lavoro',
	'sectionName_colorsAndThemes': 'Colore e tema',
	'colorsAndThemes_legacyWarning': 'Il dashboard corrente utilizza un tema di una release precedente. La modifica del tema e il salvataggio del dashboard determinerà la rimozione definitiva dell\'accesso alle tavolozze dei temi precedenti. ',
	'sectionName_details': 'Dettagli',
	'sectionName_positionAndStyle': 'Posizione & stile',
	'sectionName_appearance': 'Aspetto', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Avanzate',
	'sectionName_layout': 'Layout', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Schede',
	'sectionName_tabTitle': 'Etichetta',
	'sectionName_tabBackground': 'Sfondo',
	'addDataSourceDialogTitle': 'Aggiungi un\'origine dai',
	'addDataSourceDialogButtonLabel': 'Aggiungi',
	'shapesDoubleChevron': 'Doppia freccia',
	'widgetsPanelTitle': 'Widget',
	'widgetsPanelBasicsTab': 'Elementi di base',
	'widgetsPanelImageLibraryTab': 'Immagini',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Avanzate',
	'widgetsPanelSectionShapes': 'Forme',
	'customWidgetsTitle': 'Widget personalizzati',
	'filterItemCanvasMove': 'Aggiungi ad area di lavoro',
	'filterOverflowMenu_Global': 'Menu di overflow di tutte le schede',
	'filterOverflowMenu_Tab': 'Menu di overflow di questa scheda',
	'filterOverflowMenu_Item': 'Menu di overflow del filtro',
	'filterOverflowMenu_Single': 'Menu di overflow',
	'filterItemEdit': 'Modifica valori filtro',
	'filterDeleteAllItems': 'Elimina tutti i filtri',
	'filterClearAllItems': 'Annulla tutti i filtri',
	'filterClearSelection': 'Annulla filtro',
	'filterPlayerMode': 'Mostra player',
	'filterStaticMode': 'Mostra elenco',
	'filterInvertSelection': 'Inverti filtro',
	'filterIconLabel_Global': 'Tutte le schede',
	'filterIconLabel_Single': 'Filtri',
	'filterIconLabel_Tab': 'Questa scheda',
	'filterIconTooltip_Global': 'Tutte le schede',
	'filterIconTooltip_Tab': 'Questa scheda',
	'filterIconTooltip_Single': 'Filtri',
	'filterItemDelete': 'Elimina filtro',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'tutto tranne: %{from}-%{to}',
	'filterExcept': 'tranne %{values}',
	'filterAll': 'Tutte',
	'filterBlank': '(vuoto)',
	'filterDisableRangeInvert': 'Non disponibile quando questa colonna è nel filtro "Tutte le schede".',
	'filterDisableHierarchyInvert': 'Non disponibile quando questa colonna è un filtro della gerarchia.',
	'filterSelectedOfTotal': '%{selected} di %{totalMembers}',
	'filter_date_before': 'Prima %{to}',
	'filter_date_before_except': 'Non prima %{to}',
	'filter_date_after': 'Dopo %{from}',
	'filter_date_after_except': 'Non dopo %{from}',
	'filter_date_between': 'Compreso tra %{from}-%{to}',
	'filter_date_between_except': 'Non compreso tra %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Trascinare e rilasciare i dati in questo punto per filtrare tutte le schede.',
	'filter_drag_and_drop_current_tab': 'Trascinare e rilasciare i dati in questo punto per filtrare questa scheda.',
	'filter_drag_and_drop_single_dock': 'Trascinare e rilasciare i dati in questo punto per filtrare.',
	'errMsgFilterItemGenericTitle': 'Impossibile caricare i valori filtro',
	'widgetChromeRotate': 'Ruota',
	'toolbarRegionLabel': 'Barra degli strumenti',
	'toolbarActionDelete': 'Elimina',
	'toolbarActionGroup': 'Raggruppa',
	'toolbarActionUngroup': 'Annulla raggruppamento',
	'toolbarActionOrderToFront': 'Invia',
	'toolbarActionOrderToBack': 'Restituisci',
	'toolbarActionEditTitle': 'Modifica il titolo',
	'toolbarActionWrapTitle': 'Avvolgi Titolo a capo',
	'toolbarActionPin': 'Raccogli',
	'toolbarActionPinOld': 'Blocca',
	'toolbarActionAlign': 'Allinea',
	'alignWidgetLeft': 'Sinistra',
	'alignWidgetCenter': 'Centro',
	'alignWidgetRight': 'Destra',
	'alignWidgetTop': 'In alto',
	'alignWidgetMiddle': 'Al centro',
	'alignWidgetBottom': 'In basso',
	'toolbarChangeVisualization': 'Visualizzazione modifica',
	'multipurposeHeader': 'Selezionare un tipo di widget',
	'multipurposePlaceholderText': 'Selezionare uno dei widget per iniziare.',
	'live_label': 'Grafico',
	'filter_label': 'Filtro',
	'one_named_live': '%{name} grafico',
	'one_named_live_numbered': '%{name} grafico (%{number})',
	'one_unknown_live': 'Grafico',
	'one_unknown_live_numbered': 'Grafico (%{number})',
	'few_live': 'Gruppo di %{count} grafici',
	'many_live': 'Gruppo di %{count} grafici',
	'one_custom': 'Widget personalizzato',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Fiktro %{name}',
	'one_named_filter_numbered': '%{name} filtro (%{number})',
	'one_unknown_filter': 'Filtro',
	'one_unknown_filter_numbered': 'Filtro (%{number})',
	'few_filter': 'Gruppo di %{count} filtri',
	'many_filter': 'Gruppo di %{count} filtri',
	'LIVE_bar_has_mapping': '%{values} grafico a barre',
	'LIVE_bar_has_mapping_numbered': '%{values} grafico a barre (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} per %{values} grafico a barre',
	'LIVE_bar_opt_mapping_numbered': '%{categories} per %{values} grafico a barre (%{number})',
	'LIVE_bar_no_mapping': 'Grafico a barre vuoto',
	'LIVE_bar_no_mapping_numbered': 'Grafico a barre vuoto (%{number})',
	'LIVE_bar_named': '%{name} grafico a barre',
	'LIVE_bar_named_numbered': '%{name} grafico a barre (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} grafico a barre in pila',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} grafico a barre in pila (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} per %{values} grafico a barre in pila',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} per %{values} grafico a barre in pila (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Grafico a barre in pila vuoto',
	'LIVE_stacked_bar_no_mapping_numbered': 'Grafico a barre in pila vuoto (%{number})',
	'LIVE_stacked_bar_named': '%{name} grafico a barre in pila',
	'LIVE_stacked_bar_named_numbered': '%{name} grafico a barre in pila (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} per %{x} e %{y} grafico a bolle',
	'LIVE_bubble_has_mapping_numbered': '%{categories} per %{x} e %{y} grafico a bolle (%{number})',
	'LIVE_bubble_no_mapping': 'Grafico a bolle vuoto',
	'LIVE_bubble_no_mapping_numbered': 'Grafico a bolle vuoto (%{number})',
	'LIVE_bubble_named': '%{name} grafico a bolle',
	'LIVE_bubble_named_numbered': '%{name} grafico a bolle (%{number})',
	'LIVE_composite_has_mapping': '%{categories} per %{columnValue} e %{lineValue} grafico composito',
	'LIVE_composite_has_mapping_numbered': '%{categories} per %{columnValue} e %{lineValue} grafico composito (%{number})',
	'LIVE_composite_no_mapping': 'Grafico composito vuoto',
	'LIVE_composite_no_mapping_numbered': 'Grafico composito vuoto (%{number})',
	'LIVE_composite_named': '%{name} grafico composito',
	'LIVE_composite_named_numbered': '%{name} grafico composito (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} struttura ad albero delle decisioni',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} struttura ad albero delle decisioni (%{number})',
	'LIVE_decision_tree_no_mapping': 'Struttura ad albero delle decisioni vuota',
	'LIVE_decision_tree_no_mapping_numbered': 'Struttura ad albero delle decisioni vuoto (%{number})',
	'LIVE_decision_tree_named': '%{name} struttura ad albero delle decisioni',
	'LIVE_decision_tree_named_numbered': '%{name} struttura ad albero delle decisioni (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} grafico a bolle compresso',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} grafico a bolle compresso (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Diagramma a bolle vuoto',
	'LIVE_packed_bubble_no_mapping_numbered': 'Grafico a bolle compresso vuoto (%{number})',
	'LIVE_packed_bubble_named': '%{name} grafico a bolle compresso',
	'LIVE_packed_bubble_named_numbered': '%{name} grafico a bolle compresso (%{number})',
	'LIVE_pie_has_mapping': '%{categories} by %{values} grafico a torta',
	'LIVE_pie_has_mapping_numbered': '%{categories} by %{values} grafico a torta (%{number})',
	'LIVE_pie_no_mapping': 'Grafico a torta vuoto',
	'LIVE_pie_no_mapping_numbered': 'Grafico a torta vuoto (%{number})',
	'LIVE_pie_named': '%{name} grafico a torta',
	'LIVE_pie_named_numbered': '%{name} grafico a torta (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} per %{values} grafico ad anello',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} per %{values} grafico ad anello (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Grafico ad anello vuoto',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Grafico ad anello vuoto (%{number})',
	'LIVE_pie_as_donut_named': '%{name} grafico ad anello',
	'LIVE_pie_as_donut_named_numbered': '%{name} grafico ad anello (%{number})',
	'LIVE_line_has_mapping': '%{categories} per %{values} grafico a linee',
	'LIVE_line_has_mapping_numbered': '%{categories} per %{values} grafico a linee (%{number})',
	'LIVE_line_no_mapping': 'Grafico a linee vuoto',
	'LIVE_line_no_mapping_numbered': 'Grafico a linee vuoto (%{number})',
	'LIVE_line_named': '%{name} grafico a linee',
	'LIVE_line_named_numbered': '%{name} grafico a linee (%{number})',
	'LIVE_area_has_mapping': '%{categories} per %{values} grafico ad area',
	'LIVE_area_has_mapping_numbered': '%{categories} per %{values} grafico ad area (%{number})',
	'LIVE_area_no_mapping': 'Grafico ad area vuoto',
	'LIVE_area_no_mapping_numbered': 'Grafico ad area vuoto (%{number})',
	'LIVE_area_named': '%{name} grafico ad area',
	'LIVE_area_named_numbered': '%{name} grafico ad area (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} per %{values} grafico ad area percentuale in pila',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} per %{values} grafico ad area percentuale in pila (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Grafico ad area in pila percentuale vuoto',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Grafico ad area percentuale in pila vuoto (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} grafico ad area percentuale in pila',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} grafico ad area percentuale in pila (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} mappa di calore',
	'LIVE_heatmap_has_mapping_numbered': '%{color} mappa di calore (%{number})',
	'LIVE_heatmap_no_mapping': 'Mappa di calore vuota',
	'LIVE_heatmap_no_mapping_numbered': 'mappa di calore vuota (%{number})',
	'LIVE_heatmap_named': '%{name} mappa di calore',
	'LIVE_heatmap_named_numbered': '%{name} mappa di calore (%{number})',
	'LIVE_network_opt_mapping': '%{categories} per %{series} e %{values} rete',
	'LIVE_network_opt_mapping_numbered': '%{categories} per %{series} e %{values} rete (%{number})',
	'LIVE_network_has_mapping': '%{categories} per %{series} rete',
	'LIVE_network_has_mapping_numbered': '%{categories} per %{series} rete (%{number})',
	'LIVE_network_no_mapping': 'Rete vuota',
	'LIVE_network_no_mapping_numbered': 'Rete vuota (%{number})',
	'LIVE_network_named': '%{name} rete',
	'LIVE_network_named_numbered': '%{name} rete (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} per %{values} grafico a barre radiali',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} per %{values} grafico a barre radiali (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} grafico a barre radiali',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} grafico a barre radiali (%{number})',
	'LIVE_radial_bar_no_mapping': 'Grafico a barre radiale vuoto',
	'LIVE_radial_bar_no_mapping_numbered': 'Grafico a barre radiali vuoto (%{number})',
	'LIVE_radial_bar_named': '%{name} grafico a barre radiali',
	'LIVE_radial_bar_named_numbered': '%{name} grafico a barre radiali (%{number})',
	'LIVE_spiral_has_mapping': '%{values} grafico a spirale',
	'LIVE_spiral_has_mapping_numbered': '%{values} grafico a spirale (%{number})',
	'LIVE_spiral_no_mapping': 'Grafico a spirale vuoto',
	'LIVE_spiral_no_mapping_numbered': 'Grafico a spirale vuoto (%{number})',
	'LIVE_spiral_named': '%{name} grafico a spirale',
	'LIVE_spiral_named_numbered': '%{name} grafico a spirale (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} per %{size} mappa struttura ad albero',
	'LIVE_treemap_has_mapping_numbered': '%{categories} per %{size} Mappa struttura ad albero (%{number})',
	'LIVE_treemap_no_mapping': 'Mappa struttura ad albero vuota',
	'LIVE_treemap_no_mapping_numbered': 'Mappa struttura ad albero vuota (%{number})',
	'LIVE_treemap_named': '%{name} mappa struttura ad albero',
	'LIVE_treemap_named_numbered': '%{name} mappa struttura ad albero (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} word cloud',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} word cloud (%{number})',
	'LIVE_wordcloud_no_mapping': 'Word cloud vuoto',
	'LIVE_wordcloud_no_mapping_numbered': 'Word cloud vuoto (%{number})',
	'LIVE_wordcloud_named': '%{name} word cloud',
	'LIVE_wordcloud_named_numbered': '%{name} word cloud (%{number})',
	'LIVE_data_player_has_mapping': '%{category} data player',
	'LIVE_data_player_has_mapping_numbered': '%{category} data player (%{number})',
	'LIVE_data_player_no_mapping': 'Data player vuoto',
	'LIVE_data_player_no_mapping_numbered': 'Data player vuoto (%{number})',
	'LIVE_data_player_named': '%{name} data player',
	'LIVE_data_player_named_numbered': '%{name} data player (%{number})',
	'LIVE_map_has_mapping': '%{locations} mappa',
	'LIVE_map_has_mapping_numbered': '%{locations} mappa (%{number})',
	'LIVE_map_no_mapping': 'Mappa vuota',
	'LIVE_map_no_mapping_numbered': 'Mappa vuota (%{number})',
	'LIVE_map_named': '%{name} mappa',
	'LIVE_map_named_numbered': '%{name} mappa (%{number})',
	'LIVE_point_has_mapping': '%{categories} per %{values} grafico a punti',
	'LIVE_point_has_mapping_numbered': '%{categories} per %{values} grafico a punti (%{number})',
	'LIVE_point_no_mapping': 'Grafico a punti vuoto',
	'LIVE_point_no_mapping_numbered': 'Grafico a punti vuoto (%{number})',
	'LIVE_point_named': '%{name} grafico a punti',
	'LIVE_point_named_numbered': '%{name} grafico a punti (%{number})',
	'LIVE_column_has_mapping': '%{values} grafico a colonne',
	'LIVE_column_has_mapping_numbered': '%{values} grafico a colonne (%{number})',
	'LIVE_column_opt_mapping': '%{categories} per %{values} grafico a colonne',
	'LIVE_column_opt_mapping_numbered': '%{categories} per %{values} grafico a colonne (%{number})',
	'LIVE_column_no_mapping': 'Istogramma vuoto',
	'LIVE_column_no_mapping_numbered': 'Grafico a colonne vuoto (%{number})',
	'LIVE_column_named': '%{name} grafico a colonne',
	'LIVE_column_named_numbered': '%{name} grafico a colonne (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} grafico a colonne in pila',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} grafico a colonne in pila (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} per %{values} grafico a colonne in pila',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} per %{values} grafico a colonne in pila (%{number})',
	'LIVE_stacked_column_no_mapping': 'Istogramma in pila vuoto',
	'LIVE_stacked_column_no_mapping_numbered': 'Grafico a colonne in pila vuoto (%{number})',
	'LIVE_stacked_column_named': '%{name} grafico a colonne in pila',
	'LIVE_stacked_column_named_numbered': '%{name} grafico a colonne in pila (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} per %{x} e %{y} diagramma a dispersione',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} per %{x} e %{y} diagramma a dispersione (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} diagramma a dispersione',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} diagramma a dispersione (%{number})',
	'LIVE_scatter_no_mapping': 'Diagramma a dispersione vuoto',
	'LIVE_scatter_no_mapping_numbered': 'Diagramma a dispersione vuoto (%{number})',
	'LIVE_scatter_named': '%{name} diagramma a dispersione',
	'LIVE_scatter_named_numbered': '%{name} diagramma a dispersione (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} grafico a cascata',
	'LIVE_waterfall_has_mapping_numbered': '%{values} grafico a cascata (%{number})',
	'LIVE_waterfall_no_mapping': 'Grafico a cascata vuoto',
	'LIVE_waterfall_no_mapping_numbered': 'Grafico a cascata vuoto (%{number})',
	'LIVE_waterfall_named': '%{name} grafico a cascata',
	'LIVE_waterfall_named_numbered': '%{name} grafico a cascata (%{number})',
	'LIVE_empty_visualization_hint_title': 'Creazione della visualizzazione',
	'LIVE_empty_visualization_hint_description': 'Trascinare e rilasciare le colonne in questo punto o negli alloggiamenti a sinistra.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo obbligatorio',
	'LIVE_slots_drag_and_drop_description': 'Trascinare e rilasciare i dati negli alloggiamenti sopra riportati per creare e filtrare la visualizzazione.',
	'requiredField': 'Campo obbligatorio',
	'fullScreenEnter': 'Attiva modalità schermo intero',
	'fullScreenClose': 'Esci dalla modalità schermo intero',
	'noExtraText_multipurpose': 'Segnaposto multifunzione',
	'noExtraText_multipurpose_numbered': 'Segnaposto multiuso (%{number})',
	'one_placeholder_vis': 'Segnaposto visualizzazione',
	'one_placeholder_vis_numbered': 'Segnaposto di visualizzazione (%{number})',
	'one_placeholder_text': 'Segnaposto testo',
	'one_placeholder_text_numbered': 'Segnaposto di testo (%{number})',
	'few_placeholder_text': 'Gruppo di %{count} segnaposto di testo',
	'many_placeholder_text': 'Gruppo di %{count} segnaposto di testo',
	'filter_includesAll': 'Include tutto',
	'timeline_filter_moved_to': 'Filtro della linea temporale %{id} spostato in %{time}',
	'timelineSettingsButton': 'Opzioni di riproduzione',
	'autoPlay': 'Riproduci tutte le scene',
	'loop': 'Loop',
	'noSceneTransitionLabel': 'Nessuna',
	'sceneTransitionPropertyLabel': 'Transizione scena',
	'animatedPathSceneTransitionLabel': 'Percorso animato',
	'sweepSceneTransitionLabel': 'Ignora',
	'propAniAnimation': 'Animazione',
	'propAniTypeEntrance': 'Animazione entrata',
	'propAniDirectionIn': 'Direzione entrata',
	'propAniTypeExit': 'Animazione uscita',
	'propAniDirectionOut': 'Direzione uscita',
	'propAniDirection': 'Direzione',
	'timelineAnimationProperties': 'Apri proprietà animazione',
	'editStoryCoachMarkTitle': 'Modifica storia',
	'editStoryCoachMarkContents': 'Fare clic sull\'icona matita per modificare questa storia.',
	'addDataStoryCoachMarkContents': 'Trascinare e rilasciare i dati dal pannello di dati nella proprio storia.',
	'expandSceneCoachmarkTitle': 'Apri sequenza temporale',
	'expandSceneCoachmarkContents': 'Animare una scena regolando la visibilità dell\'oggetto in base al tempo ed alla durata.',
	'overviewCoachmarkTitle': 'Scene Panoramica',
	'overviewCoachmarkContents': 'Utilizzare le scene Panoramica per avviare e terminare la storia per rappresentare il quadro generale di tutte le scene. Da una scena panoramica, fare clic e trascinarla per scambiarla con altre scene. È possibile visualizzare o nascondere le scene panoramica nelle proprietà della storia.',
	'animatedPathCoachmarkTitle': 'Percorso animato',
	'animatedPathCoachmarkContents': 'Per animare un oggetto da una scena ad un\'altra, duplicare una scena con un oggetto. Quindi, spostare, ridimensionare o ruotare l\'oggetto duplicato nella nuova scena.',
	'tabName_animation': 'Animazione',
	'textWidgetIconPlaceholderText': 'Fare clic per aggiungere il testo',
	'buildVisHeader': 'Crea una visualizzazione',
	'visIconPlaceholderText': 'Trascinare e rilasciare i campi per creare una visualizzazione',
	'launchNewExplore': 'Nuova esplorazione',
	'addTo': 'Aggiungi a',
	'addToExisting': 'Aggiungi a esistente...',
	'exploreData': 'Esplora',
	'explore_remove_widget_styles': 'Le proprietà di visualizzazione personalizzate come ad esempio le impostazioni del colore non persisteranno nell\'esplorazione.',
	'editNotebook': 'Modifica casella di testo',
	'thumbnails_error_fetching': 'Errore durante il richiamo delle anteprime',
	'copy': '%{count} risorsa/e copiate',
	'specConvertErr': 'Si è verificato un errore durante l\'inserimento o la conversione della specifica del dashboard',
	'specCopyErr': 'Errore durante la copia della specifica del dashboard',
	'pasteNotSupportedErr': 'L\'operazione di Incolla da un %{name} non è supportata.',
	'reportParam': 'report',
	'filterWidgetCopyWarn': 'La visualizzazione del filtro non è stata copiata perché i filtri non sono attualmente supportati.',
	'upgradingDashboard': 'Aggiornamento "%{name}" per %{version}...',
	'upgradeComplete': 'Aggiornamento completo',
	'individualTabProperties': 'Proprietà della scheda individuale',
	'propMasterTabStylesLabel': 'Styling della scheda principale',
	'propTabPosition': 'Posizione scheda',
	'propTabTitle': 'Titolo',
	'propTabBackgroundColor': 'Colore riempimento',
	'propTabTextColor': 'Colore titolo',
	'propTabSelectedBarColor': 'Colore barra selezionato',
	'propTabRestoreDefaults': 'Ripristina impostazioni predefinite',
	'propIndividualTabStylesLabel': 'Styling della scheda individuale',
	'propIndividualTabStylesAriaLabel': 'Aprire le proprietà di styling della scheda singola',
	'propTabIconPosition': 'Posizione icona',
	'propLeftTitle': 'Sinistra del titolo',
	'propRightTitle': 'Destra del titolo',
	'propTopTitle': 'Sopra il titolo',
	'propBottomTitle': 'Sotto il titolo',
	'propTabIconLabel': 'Visivo',
	'propTabIcon': 'Icona',
	'propTabIconColor': 'Colore icona',
	'no_icon': 'Vuoto',
	'announcement': 'Annuncio',
	'api': 'Api',
	'archive': 'Archivio',
	'asset': 'Risorsa',
	'attachment': 'Allegato',
	'audio': 'Audio',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Segnalibro',
	'calendar': 'Calendario',
	'camera': 'Telecamera',
	'capability': 'Funzione',
	'catalog': 'Catalogo',
	'chat_message': 'Messaggio di conversazione',
	'checkout_cart': 'Carrello checkout',
	'client': 'Client',
	'clock': 'Orologio',
	'cloud': 'Nuvola',
	'code': 'Codice',
	'data_quality': 'Qualità dei dati',
	'folder': 'Cartelle',
	'forum': 'Forum',
	'glasses': 'Occhiali',
	'group': 'Raggruppa',
	'hat': 'Cappello',
	'headphone': 'Cuffie',
	'hills': 'Colline',
	'home': 'Home',
	'idea': 'Idea',
	'image': 'Immagine',
	'inventory': 'Inventario',
	'like': 'Like',
	'link': 'Collegamento',
	'location': 'Ubicazione',
	'manage': 'Gestisci',
	'pen': 'Penna',
	'mobile_phone': 'Telefono cellulare',
	'music': 'Musica',
	'notifications': 'Notifiche',
	'paint': 'Disegna',
	'payment': 'Pagamento',
	'password_key': 'Chiave password',
	'people': 'Persone',
	'person': 'Persona',
	'phone': 'Telefono',
	'pin': 'Blocca',
	'print': 'Stampa',
	'recording': 'Registrazione',
	'repository': 'Archivio',
	'role': 'Ruolo',
	'search': 'Ricerca',
	'properties': 'Proprietà',
	'speaker': 'Altroparlante',
	'star': 'Stella',
	'tag': 'Tag',
	'thumbs_up': 'Pollice in alto',
	'thumbs_down': 'Pollice verso',
	'tools': 'Strumenti',
	'traffic': 'Traffico',
	'trash': 'Cestino',
	'twitter': 'Twitter',
	'unknown': 'Sconosciuto',
	'user': 'Utente',
	'venn_diagram': 'Diagramma di Venn',
	'video': 'Video',
	'view': 'Visualizza',
	'warning': 'Avviso',
	'watch': 'Guarda',
	'watson': 'Watson',
	'wikis': 'Wiki',
	'workspace': 'Spazio di lavoro',
	'world': 'World',
	'OnLoadFilterModifierDatasourceMismatch': 'I filtri non verranno applicati alla destinazione perché i dashboard utilizzano diversi sorgenti.',
	'OnLoadFilterModifierColumnMismatch': 'Uno o più filtri non sono stati applicati perché non è stato possibile trovare la colonna/e corrispondente.',
	'eventGroupButtonLabel': 'Visualizza connessioni widget',
	'dockToolbar': 'Barra degli strumenti del dock',
	'undockToolbar': 'Sblocca barra degli strumenti',
	'propShowTitle': 'Mostra titolo'
});
